"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index25.js");var t=e.fails,i=!t(function(){return Object.isExtensible(Object.preventExtensions({}))});exports.freezing=i;
